import { LOGIN, LOGOUT } from '../../constants/Constants';

export const login = (email, password) => ({ type: LOGIN.REQUESTED, payload: { email, password } });
export const logout = () => ({ type: LOGOUT.REQUESTED });



// WEBPACK FOOTER //
// ./src/actions/login/LoginActions.js